import React from "react";
import useRegister from "./hooks/register.hook";
import RegisterView from "./view/RegisterView";
import LandingLayout from "../../include/landingLayout";

const Register = props => {
    const registerHook = useRegister();
    return (
        <>
            <LandingLayout {...props}>
                <RegisterView {...registerHook}/>
            </LandingLayout>
        </>
    )
}

export default Register;
